import { Icon, Link, LegacyStack, Tag } from '@shopify/polaris';
import { HashtagMinor, DiscountsMinor } from '@shopify/polaris-icons';
import { formatDiscount } from '../../../helpers/productHelpers';
import PvpTag from './PvpTag';

const ProductCard = ({ product, urlReturn, children, wide }) => {
  const showUserEndpoint = (id) => `/products/${id}/?r=${window.btoa(urlReturn ?? '')}`;

  return (
    <>
      {product && !wide && (
        <section className="bg-white border-b mt-2 shadow-outline rounded-xl border-gray-100 p-6 flex max-md:flex-col max-md:items-center">
          <div className="w-2/3 md:w-1/6">
            <img
              src={`${product.images[0]}`}
              alt={product.family}
              className="object-contain max-h-[250px] lg:w-[250px] pr-4 "
            />
          </div>
          <div className="w-full md:w-5/6">
            <div className="flex justify-between border-b border-gray-300 pb-2">
              <TitleData product={product} showUserEndpoint={showUserEndpoint} />
            </div>

            <div>{children}</div>
          </div>
        </section>
      )}

      {product && wide && (
        <section className="bg-white border-b mt-2 shadow-outline rounded-xl border-gray-100  max-sm:items-center">
          <div className="flex max-sm:flex-col md:items-end max-sm:pb-6">
            <div className="w-1/6">
              <img
                src={`${product.images[0]}`}
                alt={product.family}
                className="object-contain max-h-[110px] lg:w-[250px]"
              />
            </div>
            <div className="w-5/6 md:pb-8">
              <TitleData product={product} showUserEndpoint={showUserEndpoint} />
            </div>
          </div>

          <div>{children}</div>
        </section>
      )}
    </>
  );
};

const TitleData = ({ product, showUserEndpoint }) => {
  const discount = formatDiscount(product.pvp_avg, product.pvp_min);

  return (
    <div className="uppercase">
      <Link monochrome url={showUserEndpoint(product.id)}>
        <div className="font-bold mb-1">{product.title}</div>
      </Link>
      <div>
        <LegacyStack>
          <Tag>
            <LegacyStack spacing="extraTight">
              <Icon source={HashtagMinor} color="base" />
              <span>{product.family}</span>
            </LegacyStack>
          </Tag>
          <PvpTag pvpMin={product.pvp_min} pvpMax={product.pvp_max} />
          <PvpTag pvpMin={product.pvp_avg} label="PVP Medio" />
          {discount && (
            <Tag>
              <LegacyStack spacing="extraTight">
                <Icon source={DiscountsMinor} color="base" />
                <span>{`Dto. ${discount}`}</span>
              </LegacyStack>
            </Tag>
          )}
        </LegacyStack>
      </div>
    </div>
  );
};

export default ProductCard;
